import type { Finding } from '@/utils/bundleFindings'

export type CapabilityStatus = 'working' | 'needs-attention' | 'outdated' | 'answers-web-chat'

/**
 * Plain-language status for one installed skill/workflow, derived from the
 * W1-honest findings (spec §4.3). Error on the item wins ("needs-attention");
 * else an obsolete/unknown-capability warning is "outdated"; else a workflow
 * that takes over web chat is "answers-web-chat" (SA-474: it is current, not
 * outdated); else any other warning is "outdated"; else "working".
 */
export function capabilityStatus(
  findings: Finding[],
  card: 'skills' | 'workflows',
  anchorId: string,
): CapabilityStatus {
  const mine = findings.filter(
    (f) =>
      (f.location.card === card) &&
      'anchorId' in f.location &&
      f.location.anchorId === anchorId,
  )
  if (mine.some((f) => f.severity === 'error')) return 'needs-attention'
  if (mine.some((f) => /unknown_capability|not_in_catalog/.test(f.rule))) return 'outdated'
  if (mine.some((f) => f.rule === 'workflow_takes_over_web_chat')) return 'answers-web-chat'
  if (mine.some((f) => f.severity === 'warning')) return 'outdated'
  return 'working'
}
